var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.classes,
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          _vm.isClickable ? _vm.$emit("onClickLinkedObject") : null
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "activity-linked-object__text" },
        [
          _c(
            "span",
            {
              staticClass:
                "typographies-paragraph-small-semibold activity-linked-object__text-introduction",
              on: {
                click: function($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  _vm.isClickable ? _vm.$emit("onClickLinkedObject") : null
                }
              }
            },
            [_vm._v(_vm._s(_vm.introductionLabel))]
          ),
          _vm._v(" "),
          _c("CompassIcon", { attrs: { icon: _vm.icon, size: "small" } }),
          _vm._v(" "),
          _c(
            "CompassTooltip",
            {
              attrs: {
                disabled: !_vm.shouldDisplayTooltip,
                content: _vm.name,
                placement: "top",
                arrow: false
              }
            },
            [
              _c("CompassLink", {
                ref: "compassLink",
                attrs: {
                  target: "_blank",
                  link: _vm.link,
                  label: _vm.name,
                  size: "small",
                  type: "secondary"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isRemovable
        ? _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.$t.__("common.actions.delete_link"),
                arrow: false
              }
            },
            [
              _c("CompassIconButton", {
                attrs: { icon: "close", size: "small" },
                on: {
                  click: function($event) {
                    return _vm.$emit("remove")
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }